export default __webpack_public_path__ + "static/img_shadow-b72eca8a541c36f595121a0c8e053eb6.png";